module.exports = __webpack_public_path__ + "img/XW.e44322f4.jpg";